import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import { injectConfigAPI, injectFetch, TYPES as UTIL_TYPES } from '@monofe/util';
import type { IMediumDiffRequestStatus } from '../interface';
import { injectMediaDiffAPI } from '../interface';
import { bindMediaDiffAPI, TYPES, unbindMediaDiffAPI } from '../interface/bind';
import type { IMediaDiffAPI } from '../interface/mediaDiff';
import getMediaDiff from './mediaDiff';

function _build(container: IContainer): Readonly<IMediaDiffAPI> {
    const fetcher = injectFetch(container);
    const config = injectConfigAPI(container);

    const module: IMediaDiffAPI = {
        getMediaDiff: (
            authToken: string,
            siteId: number,
            siteHash = '',
            existingMedia: IMediumDiffRequestStatus[] = [],
        ) => getMediaDiff(fetcher, config, authToken, siteId, siteHash, existingMedia),
    };

    return Object.freeze(module);
}

export default buildBindable<IMediaDiffAPI>({
    id: TYPES.IMediaDiffAPI,
    dependencies: [UTIL_TYPES.IFetch, UTIL_TYPES.IConfigAPI],
    bind: bindMediaDiffAPI,
    remove: unbindMediaDiffAPI,
    build: container => Promise.resolve(_build(container)),
    inject: injectMediaDiffAPI,
});
